import makeApiCall from './makeApiCall';

export const getFilterAgenda = (params) => makeApiCall(`/agendas/list`, `GET`, params);
export const getFilterSpecialty = (params) => makeApiCall(`/user/specialty`, `GET`, params);
export const getPushProductWeeklySummary = (params) =>
  makeApiCall(`/push-products/weekly-summary/export`, `POST`, params);

// Call Volume vs Product Usage Report
export const getCallVolumeVsProductUsageReport = (params) =>
  makeApiCall(`/products/call-volume-product-usage/report/export`, `POST`, params);

export const getProductSamplingReport = (params) =>
  makeApiCall(`/products/sampling/report/export`, `POST`, params);

// Product Sampling Inventory Export
export const getProductSamplingInventory = (params) =>
  makeApiCall(`/products/sampling/inventory/maintenance/export`, `POST`, params);
